import { defineNuxtPlugin } from "#app";
import { useRuntimeConfig, useRoute, watch } from "#imports";
import { load } from "fathom-client";
import { useFathom } from "./composables/useFathom.mjs";
export default defineNuxtPlugin(() => {
  const {
    fathom: { siteId, config }
  } = useRuntimeConfig().public;
  if (!siteId)
    return;
  load(siteId, config);
  if (!config?.manual) {
    const { trackPageview } = useFathom();
    const route = useRoute();
    watch(
      () => route.path,
      () => {
        trackPageview();
      }
    );
  }
});
